import clsx, { type ClassValue } from 'clsx'

/** Merge class names. Thin wrapper around clsx (no Tailwind conflict resolution needed
 *  because our primitives use design-CSS classes, not arbitrary utility stacks). */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs)
}
